module.exports = __webpack_public_path__ + "img/raf-account-banner-bg.1817950.png";